import { render, staticRenderFns } from "./DashboardWelcome.vue?vue&type=template&id=55b68970&"
import script from "./DashboardWelcome.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcome.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWelcome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports